module.exports = __webpack_public_path__ + "img/download-file.4bf8e601.svg";